<template>
  <div class="home">
    <banner />
    <div style="width: 1200px; margin: 0 auto 25px; background: white">
      <!--        个人中心-->

      <!-- 如果登录了 -->
      <div class="info" v-if="userInfo">
        <el-row class="info-data" type="flex" align="bottom">
          <el-col :span="7">
            <div class="icon_h"></div>
          </el-col>
          <el-col :span="4">省份 &nbsp;<span>河南</span></el-col>
          <el-col :span="4">科类&nbsp;<span>{{
            userInfo.is_wenli == 1 ? "文科" : "理科"
          }}</span></el-col>
          <el-col :span="4">分数&nbsp;<span>{{
            userInfo.score ? userInfo.score : '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;'
          }}分</span></el-col>
          <el-col :span="5">位次&nbsp;<span>{{
            userInfo.ranking ? userInfo.ranking : '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;'
          }}名</span></el-col>
        </el-row>
        <div class="icon">
          <div class="box">
            <div class="img img-1"></div>
            <div class="title">冲一冲</div>
            <div class="num">
              <span>{{ NumList.first }}&nbsp;</span>所院校
            </div>
          </div>
          <div class="box">
            <div class="img img-2"></div>
            <div class="title">稳一稳</div>
            <div class="num">
              <span>{{ NumList.two }}&nbsp;</span>所院校
            </div>
          </div>
          <div class="box">
            <div class="img img-3"></div>
            <div class="title">保一保</div>
            <div class="num">
              <span>{{ NumList.three }}&nbsp;</span>所院校
            </div>
          </div>
          <div class="box">
            <div class="img img-4"></div>
            <div class="title">垫一垫</div>
            <div class="num">
              <span>{{ NumList.four }}&nbsp;</span>所院校
            </div>
          </div>
        </div>
        <div class="foot">
          <span style="font-size:12px;color:#a7a7a7;position: relative;
    ">仅限日常参考使用，模拟填报期间请选择智能填报模块</span>
          <router-link to="/Recommend" style="position: relative;right: -370px;">查看详情></router-link>

        </div>
      </div>
      <!-- 如果没有登录 -->

      <div class="info" v-else>
        <el-row class="info-data">
          <el-col :span="7">
            <div class="icon_h"></div>
          </el-col>
        </el-row>
        <el-row style="margin-left: 50px">
          <el-col :span="8"><span class="title_info">所在省份</span>
            <span class="title_data">河南</span>
          </el-col>
          <el-col :span="13">
            <span class="title_info">科类选择</span>
            <span class="radio" style="font-size: 16px">
              <el-radio v-model="is_wenli" label="1" @change="getRanking">文科</el-radio>
              <el-radio v-model="is_wenli" label="2" @change="getRanking">理科</el-radio>
            </span>
          </el-col>
        </el-row>
        <el-row style="margin-left: 50px">
          <el-col :span="8"><span class="title_info">高考年份</span>
            <span class="title_data">2023</span>
          </el-col>
          <el-col :span="8">
            <span class="title_info">预测分数</span>
            <span>
              <input type="text" class="info_input" @change="getRanking" v-model="score" />
            </span>
            <span class="title_info_1">分</span>
          </el-col>
          <el-col :span="8">
            <span class="title_info">所处位次</span>
            <span>
              <input type="text" class="info_input" v-model="ranking" disabled />
            </span>
            <span class="title_info_1">名</span>
          </el-col>
        </el-row>
        <el-row type="flex" align="bottom" style="margin-left: 50px; margin-top: 15px; font-size: 12px">
          <el-col :span="20" class="brief">备注：该推荐只是基于您提供科目、成绩及位次进行简单大数据推荐，仅供参考，不推荐作为填报志愿的依据。</el-col>
          <el-col :span="4">
            <el-button type="primary" class="button" round @click="toRecommend">查看推荐</el-button>
          </el-col>
        </el-row>
      </div>

      <!--倒计时-->
      <countdown />
    </div>
    <recommend />
    <tools />
    <news />
    <hotCollege />
    <hotMajor />
    <core />
    <div style="height:1px">
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import recommend from "./components/recommend";
import news from "./components/news";
import banner from "./components/banner";
import tools from "./components/tools";
import core from "./components/core";
import countdown from "./components/countdown";
import hotCollege from "./components/hotCollege";
import hotMajor from "./components/hotMajor";

export default {
  computed: {
    ...mapState(["userInfo"]),
  },
  name: "index",
  components: {
    recommend,
    news,
    tools,
    banner,
    core,
    countdown,
    hotCollege,
    hotMajor,
  },
  data() {
    return {
      batch: "1",
      is_wenli: "1",
      score: "",
      ranking: "",
      NumList: [],
    };
  },
  mounted() {
    if (this.userInfo) {
      this.score = this.userInfo.score;
      this.is_wenli = this.userInfo.is_wenli;
      this.ranking = this.userInfo.ranking;
      this.getSchoolNum();
    }
  },
  methods: {
    //推荐跳转
    toRecommend() {
      if (this.score) {
        this.$router.push({
          path: "Recommend",
          query: {
            score: this.score,
            is_wenli: this.is_wenli,
            ranking: this.ranking,
          },
        });
      } else {
        this.$message.error("请输入分数");
      }
    },
    //获取学校数量
    getSchoolNum() {
      if (this.is_wenli == 1) {
        if (this.score < 558) {
          this.batch = "2";
        }
      } else {
        if (this.score < 518) {
          this.batch = "2";
        }
      }
      let data = {
        score: this.score,
        is_wenli: this.is_wenli,
        batch: this.batch,
      };
      this.$fecth.post("Recommend/getSchoolNum", data).then((res) => {
        this.NumList = res;
      });
    },
    getRanking() {
      let data = {
        is_wenli: this.is_wenli,
        score: this.score,
      };
      this.$fecth.post("score/getRanking", data).then((res) => {
        this.ranking = res;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.home {
  background: #f4f4f4;

  .main {
    width: 1100px;
    margin: 0 auto 25px;
    background: white;
    padding: 25px 50px;
    font-size: 18px;

    .title {
      font-size: 18px;
      color: #2570fd;
      text-indent: 1rem;
      border-left: 1px solid #2570fd;
    }
  }

}

.info {
  display: inline-block;
  width: 886px;

  .info-data {
    font-size: 18px;
    padding: 34px 50px 10px 50px;

    span {
      border-radius: 40px;
      border: 1px solid #3479f8;
      color: #3479f8;
      padding: 2px 14px;
      line-height: 40px;
    }

    .icon_h {
      height: 40px;
      background: url("../../assets/img/home/ai-icon.png") no-repeat;
    }
  }

  .icon {
    display: flex;
    justify-content: center;
  }

  .icon .box {
    width: 25%;
    text-align: center;
    font-size: 18px;

    .img {
      margin-top: 18px;
      margin-left: 73px;
      height: 80px;
    }

    .img-1 {
      background: url("../../assets/img/home/home-bg.png") no-repeat 0 -150px;
    }

    .img-2 {
      background: url("../../assets/img/home/home-bg.png") no-repeat 0 -250px;
    }

    .img-3 {
      background: url("../../assets/img/home/home-bg.png") no-repeat 0 -350px;
    }

    .img-4 {
      background: url("../../assets/img/home/icon4.png") no-repeat;
    }

    .title {
      margin-top: 10px;
    }

    .num span:first-child {
      color: red;
    }
  }

  .foot {
    margin-top: 30px;
    font-size: 20px;
    padding: 0 60px;
    margin-bottom: 10px;

    a {
      color: #2365fa;
      margin-right: 14px;
    }
  }

  .title_info {
    display: inline-block;
    font-size: 18px;
    color: #6c6b6b;
    margin: 35px 0 15px;
  }

  .title_info_1 {
    position: relative;
    left: -30px;
    top: -2px;
    color: #c9c8c8;
  }

  .radio {
    display: inline-block;
    margin-left: 24px;
  }

  .title_data {
    font-size: 18px;
    margin-left: 14px;
    color: #2b7bf3;
  }

  .info_input {
    border-radius: 30px;
    width: 100px;
    border: 1px solid #6c6b6b;
    margin-left: 20px;
    line-height: 23px;
    height: 23px;
    position: relative;
    outline: none;
    top: -3px;
    text-indent: 1rem;
  }

  .info_input:focus {
    border-radius: 30px;
    border: 1px solid #6c6b6b;
    color: #2b7bf3;
  }

  .button {
    width: 120px;
    line-height: 7px;
    height: 30px;
  }

  .brief {
    color: #e0dfdf;
  }
}
</style>

<style lang="less" >
.home {
  .el-divider--horizontal {
    margin: 11px 0;
  }

  .info {
    .el-radio__label {
      font-size: 18px;
    }
  }
}
</style>